import { Contract } from '../../../../../common/validations'
import {
  ContractChangesSection,
  TerminationDisallowedReason,
} from '../../../../../common/types'
import { resolveContractChangesSection } from '../../../../../common/resolveContractChangesSection'

const OTHER_SECTION_REASONS: Record<
  ContractChangesSection,
  TerminationDisallowedReason[]
> = {
  [ContractChangesSection.TERMINATE_CONTRACT]: [
    TerminationDisallowedReason.CONTRACT_TERMINATED,
    TerminationDisallowedReason.PENDING_TERMINATION_REVIEW,
    TerminationDisallowedReason.PENDING_TERMINATION_TENANT_APPROVALS,
  ],
  [ContractChangesSection.RESIDENT_CHANGES]: [
    TerminationDisallowedReason.NOT_CONTRACT_PARTY,
  ],
}

export const linksToOtherSection = (
  contract: Contract,
  otherSection: ContractChangesSection
) => {
  const reason = contract.terminationDisallowedReason

  if (reason === TerminationDisallowedReason.PENDING_MODIFICATION_REQUEST) {
    return (
      contract.modificationRequest !== undefined &&
      resolveContractChangesSection(
        contract.modificationRequest.isContractPartyMoveOut
      ) === otherSection
    )
  }

  return (
    reason !== undefined && OTHER_SECTION_REASONS[otherSection].includes(reason)
  )
}
